import { GridRowData } from '@material-ui/data-grid';
import {
  AssetEntity,
  FenceEntityType,
  GeoJsonType,
  MicrofenceEntity,
  SearchTypeIDs,
} from '../../util/enums';

export const microfenceTypeOfEntity = (entity: GridRowData): MicrofenceEntity | undefined => {
  const type = (entity?.type ?? entity?.points?.type)?.toLowerCase();
  if (!type) return;
  if (type === MicrofenceEntity.Beacon) {
    return MicrofenceEntity.Beacon;
  } else if (type === MicrofenceEntity.Device) {
    return MicrofenceEntity.Device;
  } else if (type === MicrofenceEntity.Gateway) {
    return MicrofenceEntity.Gateway;
  }
  return;
};

export const geometryTypeOfEntity = (entity: GridRowData): FenceEntityType | undefined => {
  const type = (entity?.type ?? entity?.points?.type)?.toLowerCase();
  if (microfenceTypeOfEntity(entity)) {
    return FenceEntityType.Microfence;
  } else if (type === FenceEntityType.Multipolygon) {
    return FenceEntityType.Multipolygon;
  } else if (type === FenceEntityType.Polygon) {
    return FenceEntityType.Polygon;
  } else if (type?.startsWith(FenceEntityType.Line)) {
    return FenceEntityType.Line;
  }
  return;
};

// Microfence is not actually a valid geoJson. But we have it here, basically to have the inverse of the function above.
export const geojsonTypeOfEntity = (entity: GridRowData): GeoJsonType | undefined => {
  const type = (entity?.type ?? entity?.points?.type)?.toLowerCase();
  if (!type) return;
  if (microfenceTypeOfEntity(entity)) {
    return GeoJsonType.Microfence;
  }
  if (type === FenceEntityType.Multipolygon) {
    return GeoJsonType.Multipolygon;
  } else if (type === FenceEntityType.Polygon) {
    return GeoJsonType.Polygon;
  } else if (type?.startsWith(FenceEntityType.Line)) {
    return GeoJsonType.Linestring;
  }
  return;
};

export const assetTypeOfEntity = (
  id: Record<string, string | undefined>,
  isTool?: boolean,
): AssetEntity => {
  if (id.beaconId) {
    if (isTool) {
      return AssetEntity.Tool;
    }
    return AssetEntity.Beacon;
  } else if (id.deviceId) {
    return AssetEntity.Device;
  } else if (id.mqttgatewayId) {
    return AssetEntity.MqttGateway;
  } else if (id.gpsTrackerId) {
    return AssetEntity.GpsTracker;
  } else if (id.uuid && id.major && id.minor) {
    return AssetEntity.Beacon;
  }
  return AssetEntity.Unknown;
};

export const assetEntityToSearchId = (assetEntity: AssetEntity): SearchTypeIDs | undefined => {
  if (assetEntity === AssetEntity.Beacon) {
    return SearchTypeIDs.Beacons;
  } else if (assetEntity === AssetEntity.Device) {
    return SearchTypeIDs.Devices;
  } else if (assetEntity === AssetEntity.MqttGateway) {
    return SearchTypeIDs.Microfences;
  } else if (assetEntity === AssetEntity.GpsTracker) {
    return SearchTypeIDs.GPSTrackers;
  } else if (assetEntity === AssetEntity.Tool) {
    return SearchTypeIDs.Tools;
  }
};

export const searchIdToAssetEntity = (searchId: SearchTypeIDs): AssetEntity => {
  if (searchId === SearchTypeIDs.Beacons) {
    return AssetEntity.Beacon;
  } else if (searchId === SearchTypeIDs.Devices) {
    return AssetEntity.Device;
  } else if (searchId === SearchTypeIDs.Microfences) {
    return AssetEntity.MqttGateway;
  } else if (searchId === SearchTypeIDs.GPSTrackers) {
    return AssetEntity.GpsTracker;
  } else if (searchId === SearchTypeIDs.Tools) {
    return AssetEntity.Tool;
  }
  return AssetEntity.Unknown;
};

export const getAssetIdentifierFieldType = (asset: AssetEntity) => {
  if (asset === AssetEntity.Device) {
    return 'Code';
  } else if (asset === AssetEntity.GpsTracker) {
    return 'Serial';
  }
  return 'ID';
};

export const getAssetLabelFieldType = (asset: AssetEntity) => {
  if (asset === AssetEntity.Device) {
    return 'ID';
  } else if (asset === AssetEntity.Tool) {
    return 'Label/Serial';
  }
  return 'Label';
};
